import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, Autoplay, Controller } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";

const galleryImages = [
  "best-price-car-1-1.png",
  "best-price-car-1-2.png",
  "best-price-car-1-3.png",
  "best-price-car-1-4.png",
  "best-price-car-1-5.png",
  "best-price-car-1-6.png",
];

const carDetails = [
  {
    price: "Urbania on Rent",
    name: "13 Seater Force Urbania – Pune",
  },
  {
    price: "Luxury Travel",
    name: "17 Seater Force Urbania – Pune",
  },
  {
    price: "Premium Tour",
    name: "Urbania for Corporate & Tours",
  },
  {
    price: "Outstation Ready",
    name: "Urbania for Long Trips",
  },
  {
    price: "Wedding Travel",
    name: "Urbania Rental for Events",
  },
  {
    price: "Comfort Ride",
    name: "Urbania with AC & Pushback Seats",
  },
];

const BestPriceCars = () => {
  const [contentSwiper, setContentSwiper] = useState(null);

  return (
    <section className="best-price-car-sec-1 space-top overflow-hidden">
      {/* TITLE */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="title-area text-center">
              <h2 className="sec-title">Urbania on Rent in Pune</h2>
              <p>
                Book Force Urbania in Pune for corporate travel, tours, weddings,
                and outstation trips. Spacious, luxury, and professional service.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* IMAGE SLIDER (MASTER) */}
      <div className="container-fluid p-0">
        <Swiper
          modules={[Autoplay, Thumbs, Controller]}
          loop
          centeredSlides
          spaceBetween={60}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          thumbs={{ swiper: contentSwiper }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
          }}
          className="bestPriceContentSlide"
        >
          {galleryImages.map((img, index) => (
            <SwiperSlide key={index}>
              <div className="best-price-car-gallery-1">
                <div className="best-price-car-box">
                  <img
                    src={`/img/best-price-car/${img}`}
                    alt="Urbania on Rent Pune"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* CONTENT SLIDER (SYNCED) */}
      <div className="container th-container3">
        <Swiper
          modules={[Navigation, Thumbs, Controller]}
          onSwiper={setContentSwiper}
          loop
          centeredSlides
          spaceBetween={10}
          slidesPerView={1}
          navigation
          allowTouchMove={false} // prevents mismatch
          className="best-price-car-content-slider"
        >
          {carDetails.map((car, index) => (
            <SwiperSlide key={index}>
              <div className="feature-list-1 best-price-car-content">
                <div className="car-content text-center">
                  <h6 className="box-title-price">{car.price}</h6>

                  <h3 className="box-title">{car.name}</h3>

                  <ul className="car-feature justify-content-center">
                    <li>AC</li>
                    <li className="divider"></li>
                    <li>Pushback Seats</li>
                    <li className="divider"></li>
                    <li>Luxury Travel</li>
                  </ul>

                  <div className="car-bottom justify-content-center">
                    <a href="/contact" className="link-btn">
                      Book Urbania Now
                      <i className="fas fa-arrow-up-right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default BestPriceCars;
